import { DiscountGiftRow } from '@models/discount';
import { CreateOrderRequest, GiftPayment } from '@models/order';
import { PayloadAction, WritableDraft } from '@reduxjs/toolkit';

export function toggleGift(
    state: WritableDraft<CreateOrderRequest>,
    action: PayloadAction<DiscountGiftRow>,
) {
    const { id, discountValue, couponType } = action.payload;
    const exists = !!state.giftPayments
        ?.find((it) => it.giftCouponId === id);
    if (exists) {
        state.giftPayments = state.giftPayments!
            .filter((it) => it.giftCouponId !== id);
    } else {
        state.giftPayments = [...(state.giftPayments || []), {
            giftCouponId: id,
            amount: discountValue,
            type: couponType,
        }];
    }
}

export function setGiftPayments(
    state: WritableDraft<CreateOrderRequest>,
    action: PayloadAction<GiftPayment[]>,
) {
    state.giftPayments = action.payload;
}
